import CertificateWithoutRatingFinalReview from "../../features/ServiceCertificateGrouping/FinalApprovalCertificate/CertificateWithoutRating/CertificateWithoutRatingFinalReview";
import "./CertificateGroupingWIthoutRatingFinalReview.scss";


const CertificateGroupingWIthoutRatingFinalReview = () => {
  return (
    <div className="analytics-page">
      <CertificateWithoutRatingFinalReview />
    </div>
  );
};

export default CertificateGroupingWIthoutRatingFinalReview;
